/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import type { EmbeddedContentProps } from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedContent';
import EmbeddedLink from 'bundles/compound-assessments/components/shared/embeddedContent/EmbeddedLink';
import RenderPreviewTitle from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewTitle';
import RenderPreviewUnavailable from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewUnavailable';

const styles = {
  renderContainer: () => css`
    margin: var(--cds-spacing-200) 0;
  `,
  audio: () => css`
    width: 100%;
  `,
};

export const EmbeddedAudio: React.FC<EmbeddedContentProps> = ({ url, title }: EmbeddedContentProps) => {
  const [fileAvailable, setFileAvailable] = useState(true);
  return (
    <div>
      <EmbeddedLink url={url} title={title} />
      {fileAvailable ? (
        <div css={styles.renderContainer}>
          <RenderPreviewTitle />
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <audio
            src={url}
            title={title}
            css={styles.audio}
            controls={true}
            preload="metadata"
            onError={() => setFileAvailable(false)}
          />
        </div>
      ) : (
        // for audio/video validFileSize is just fileAvailability because we only pre-load metadata
        // and allow any size media to be played
        <RenderPreviewUnavailable fileAvailable={fileAvailable} validFileSize={fileAvailable} />
      )}
    </div>
  );
};

export const isEmbeddedAudio = (url: string) => {
  const regex = /\.(mp3|wav)$/i;
  return url.match(regex);
};

export default EmbeddedAudio;
